import * as AiServiceInterfaces from './ai-service';
import * as ChronologyServiceInterfaces from './chronology-service';
import * as DictionaryServiceInterfaces from './dictionary-service';
import * as FileServiceInterfaces from './file-service';
import * as NotificationServiceInterfaces from './notification-service';

import * as ProfileEmployeeServiceInterfaces from './profile-service/profile-employee';
import * as ProfileEntitiesServiceInterfaces from './profile-service/profile-entities';
import * as ProfileExternalServiceInterfaces from './profile-service/profile-external';
import * as ProfileLookupServiceInterfaces from './profile-service/profile-lookup';
import * as ProfilePayloadServiceInterfaces from './profile-service/profile-payload';
import * as ProfileRequestServiceInterfaces from './profile-service/profile-request';
import * as ProfileResponseServiceInterfaces from './profile-service/profile-response';

import * as RecruiterServiceInterfaces from './recruiter-service';
import * as ShortlistServiceInterfaces from './shortlist-service';
import * as StatisticServiceInterfaces from './statistic-service';
import * as VacancyServiceInterfaces from './vacancy-service';

export namespace Internal {
  export import Ai = AiServiceInterfaces;

  export import Chronology = ChronologyServiceInterfaces;

  export import Dictionary = DictionaryServiceInterfaces;

  export import File = FileServiceInterfaces;

  export import Notification = NotificationServiceInterfaces;

  export namespace Profile {
    export import Employee = ProfileEmployeeServiceInterfaces;
    export import Entities = ProfileEntitiesServiceInterfaces;
    export import External = ProfileExternalServiceInterfaces;
    export import Payload = ProfilePayloadServiceInterfaces;
    export import Request = ProfileRequestServiceInterfaces;
    export import Response = ProfileResponseServiceInterfaces;
    export import Lookup = ProfileLookupServiceInterfaces;
    export namespace AiSuggestion {
      export interface MarkPayload {
        status: AiSuggestion.Status;
        vacancyId: number;
      }
      export enum Status {
        ACCEPTED = 'accepted',
        REJECTED = 'rejected',
        SHORTLISTED = 'shortlisted',
      }
    }
  }

  export import Recruiter = RecruiterServiceInterfaces;

  export import Shortlist = ShortlistServiceInterfaces;

  export import Statistic = StatisticServiceInterfaces;

  export import Vacancy = VacancyServiceInterfaces;
}
